<template>
  <div class="swiper-wrap">
    <swiper :options="swiperOption" ref="mySwiper" class="">
      <swiper-slide v-for="(item,index) in data" :key="index">
        <div class="banner-item" v-if="type == 'banner'">
          <img :src="item.image" :alt="item.title" class="banner-image"/>
          <div class="mask"></div>
          <div class="main">
            <div class="title els">{{ item.title }}</div>
            <DButton :width="300" :height="87" :font-size="32" text="下载游戏" :id="item.id"></DButton>
          </div>
        </div>
        <div v-else class="pic-item">
          <div class="pic-title">{{ item.title }}</div>
          <div class="pic-subtitle">{{ item.subtitle }}</div>
          <img :src="item.image" />
        </div>
      </swiper-slide>
      <div :style="{display:type == 'banner' && !pagination?'none':'block'}"  class="swiper-pagination" slot="pagination" ></div>
    </swiper>
    <div v-if="type == 'banner' && !pagination" class="thumbnail">
      <div class="thumbnail-wrap">
        <div v-for="(item,index) in data" :key="index" class="thumbnail-item" :class="{active:activeIndex == index}" @click="onPreview(index)">
          <img :src="item.thumbnail || getThumbnail(item.image)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import DButton from '@/components/DButton.vue'
export default {
  components: {
    swiper,
    swiperSlide,
    DButton
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'banner'
    },
    perview: {
      type: Number,
      default: 1
    },
    pagination: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: true
    },
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const self = this
    return {
      activeIndex: 0,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        speed: 1000,
        effect: this.type === 'banner' && !this.pagination ? 'fade' : 'slide',
        loop: this.loop,
        autoplay: this.autoplay,
        slidesPerView: this.perview,
        centeredSlides: true,
        on: {
          slideChangeTransitionStart  () {
            self.activeIndex = this.realIndex
          }
        }
      }
    }
  },
  methods: {
    onPreview (index) {
      this.$refs.mySwiper.swiper.slideTo(index, 1000)
    },
    getThumbnail (src) {
      return src.replace(/.com/, '.com/dr/300__')
    }
  }
}
</script>

<style lang="scss">
.swiper-wrap,.swiper-container,.banner-item{
  width: 100%;
  height: 100%;
}
.swiper-wrap{
  position: relative;
}
.banner-item{
  background-size: cover;
  background-position: center center;
  .banner-image{
    object-fit: cover;
    width: 100%;
    height: 100vh;
    position: absolute;
  }
}
.thumbnail{
  width: 100%;
  position: absolute;
  bottom:0;
  background: linear-gradient(180deg, #00000000 0%, #1e1e20 100%);
  z-index: 1;
  .thumbnail-wrap{
    width: 12.00rem;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .thumbnail-item{
    width: 2.68rem;
    height: 1.51rem;
    cursor: pointer;
    transition: all 0.5s;
    img{
      height: 100%;
    }
  }
  .thumbnail-item.active{
    width: 3.36rem;
    height: 1.89rem;
    border: 2px solid #ffdc00;
  }
}
.swiper-container-horizontal > .swiper-pagination-bullets{
  display: none;
  bottom: 37px;
  font-size: 0;
}

.swiper-pagination-bullet {
  width: .25rem;
  height: .10rem;
  background: #fff;
  border-radius: 1.00rem;
  outline: 0;
  opacity: 1;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: .60rem;
  background: #ffdc00;
}
@media (max-width: 1200px){
  .swiper-container{
    width: 100%;
  }
  .swiper-pagination-bullet {
    width: .1rem;
    height: .1rem;
  }
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: .44rem;
  }
}
</style>
